import React from 'react';
import DropdownMenu from './DropdownMenu';
import DropdownMenuItem from './DropdownMenuItem';

const options = [
  {
    label: 'Review performance',
    value: 'report',
    className: 'campaign_dropdown',
    key: 'report',
  },
  {
    label: 'View and edit details',
    value: 'edit',
    className: 'campaign_dropdown',
    key: 'edit',
  },
  {
    label: 'Copy Webhook Link',
    value: 'copy',
    className: 'campaign_dropdown',
    key: 'copy',
  },
  {
    label: 'Delete',
    value: 'Delete',
    className: 'campaign_dropdown',
    key: 'delete',
  },
];
const StatusSelectDropdown = ({
  onChange,
  selectedOption,
  dropdownMenu,
  ...rest
}) => {
  const filteredOptions = options.filter(
    (option) => dropdownMenu[option.key] === true,
  );
  return (
    <DropdownMenu {...rest}>
      {/* eslint react/no-array-index-key: "off" */
      filteredOptions.map((item, index) => {
        return (
          <DropdownMenuItem
            label={item.label}
            key={index}
            value={item.value}
            onClick={onChange}
            type="BUTTON"
            className={item.className}
          />
        );
      })}
    </DropdownMenu>
  );
  //}
};

export default StatusSelectDropdown;
